interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loadingText?: string;
  variant?: "primary" | "secondary";
  fullWidth?: boolean;
}

const VARIANT_STYLES: Record<NonNullable<ButtonProps["variant"]>, string> = {
  primary: "bg-accent text-ink",
  secondary: "bg-white text-ink",
};

export function Button({
  loading,
  loadingText,
  variant = "primary",
  fullWidth = true,
  children,
  disabled,
  className = "",
  ...props
}: ButtonProps) {
  return (
    <button
      disabled={loading || disabled}
      className={`${fullWidth ? "w-full" : "w-auto"} rounded-xl border-2 border-ink py-3.5 text-[15px] font-extrabold shadow-[4px_4px_0_0_#1D1F1A] transition-transform active:translate-x-[3px] active:translate-y-[3px] active:shadow-[1px_1px_0_0_#1D1F1A] disabled:pointer-events-none disabled:opacity-50 ${VARIANT_STYLES[variant]} ${className}`}
      {...props}
    >
      {loading ? (loadingText ?? "Chargement...") : children}
    </button>
  );
}
